module.exports = __webpack_public_path__ + "static/img/2.bcd5ecee.jpg";